import { ChangeEvent, FC } from 'react'

import { Input } from '@/shared/ui'

type SearchFieldProps = {
	value?: string
	onChange?: (evt: ChangeEvent<HTMLInputElement>) => void
	ariaLabel?: string
	className?: string
	isDisabled?: boolean
}

export const SearchField: FC<SearchFieldProps> = ({ value, onChange, ariaLabel, className, isDisabled }) => {
	const onChangeHandler = (evt: ChangeEvent<HTMLInputElement>) => {
		evt.preventDefault()
		evt.stopPropagation()
		onChange?.(evt)
	}

	return (
		<Input
			onChange={onChangeHandler}
			type="search"
			label="Найти"
			value={value}
			aria-label={ariaLabel}
			className={className}
			disabled={isDisabled}
		/>
	)
}
